<div>
  <div class="space-y-4">
    @if (tiene_tipo_pago() === true) {
      <div class="mb-4">
        <label class="block text-gray-700 mb-2">Tipo de Pago *</label>
        <app-select
          [options]="optionsTipoPago$ | async"
          [formField]="$any(formApertura.tipo_pago)"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccionar pago"
          class="w-full"
          appendTo="body"
          [class.p-invalid]="
            formApertura.tipo_pago().invalid() && formApertura.tipo_pago().touched()
          "
        />
        @if (formApertura.tipo_pago().invalid() && formApertura.tipo_pago().touched()) {
          <small class="p-error">{{ formApertura.tipo_pago().errors() | formErrorMessage }}</small>
        }
      </div>
    }
    <div>
      <label class="block text-gray-700 mb-2">{{ form_monto_texto() }}</label>
      <div class="relative">
        <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">S/.</span>
        <input
          type="number"
          [formField]="$any(formApertura.monto)"
          placeholder="0.00"
          class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          [class.p-invalid]="formApertura.monto().invalid() && formApertura.monto().touched()"
        />
      </div>
      @if (formApertura.monto().invalid() && formApertura.monto().touched()) {
        <small class="p-error">{{ formApertura.monto().errors() | formErrorMessage }}</small>
      }
    </div>

    <div>
      <label class="block text-gray-700 mb-2">{{ form_descripcion_texto() }}</label>
      <textarea
        placeholder="Ej: Turno mañana, Caja principal..."
        [formField]="$any(formApertura.descripcion)"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
        [class.p-invalid]="
          formApertura.descripcion().invalid() && formApertura.descripcion().touched()
        "
      ></textarea>
      @if (formApertura.descripcion().invalid() && formApertura.descripcion().touched()) {
        <small class="p-error">{{ formApertura.descripcion().errors() | formErrorMessage }}</small>
      }
    </div>

    @if (form_anuncio() !== '') {
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div class="flex items-start gap-2">
          <i class="bi bi-info-circle text-blue-500 text-2xl mt-1"></i>
          <p class="text-sm text-blue-700">
            {{ form_anuncio() }}
          </p>
        </div>
      </div>
    }
  </div>

  <div class="flex gap-3 mt-6">
    <button
      class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
      (click)="onCerrar()"
    >
      {{ form_boton_cancelar_texto() }}
    </button>
    <button
      class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      (click)="modal_confirmar.set(true)"
      [disabled]="formApertura().invalid()"
    >
      {{ form_boton_confirmar_texto() }}
    </button>
  </div>
</div>
@if (tiene_confirmacion()) {
  <app-dialog
    [header]="confirmar_titulo()"
    [modal]="true"
    [(visible)]="modal_confirmar"
    (onHide)="modal_confirmar.set(false)"
    size="xs"
  >
    <app-modal-confirmacion
      [mensaje]="confirmar_texto()"
      botonTexto="Confirmar Apertura"
      [textoConfirm]="confirmar_boton_confirmar_texto()"
      (confirmar)="confirmar()"
      [textoCancel]="confirmar_boton_cancelar_texto()"
      (cancelar)="modal_confirmar.set(false)"
    />
  </app-dialog>
}
